import { render, staticRenderFns } from "./call-records.vue?vue&type=template&id=ad9878ce&scoped=true&"
import script from "./call-records.vue?vue&type=script&lang=js&"
export * from "./call-records.vue?vue&type=script&lang=js&"
import style0 from "./call-records.vue?vue&type=style&index=0&id=ad9878ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9878ce",
  null
  
)

export default component.exports